/*
 * HomeFixer360 - Payment Cancelled Page
 * Copyright (c) 2025 Guy T. Dunn Sr. / Idea Guy Brands Incorporated
 * All Rights Reserved.
 */

import React from 'react';
import { X, ArrowLeft, Zap, DollarSign } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancelled = () => {
  const getUrlParameter = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  };

  const packageId = getUrlParameter('package_id');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white p-8 text-center">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
            <X className="w-12 h-12 text-orange-500" />
          </div>
          <h1 className="text-3xl font-bold mb-2">Payment Cancelled</h1>
          <p className="text-orange-100">Your presale order was not completed</p>
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="text-center mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">No worries! Your presale spot is still available.</h2>
            <p className="text-gray-600 mb-6">
              You cancelled the payment process, but don't miss out on these limited-time presale savings.
            </p>
          </div>

          {/* Reminder of Benefits */}
          <div className="bg-gradient-to-r from-red-50 to-orange-50 rounded-lg p-6 mb-6 border border-orange-200">
            <h3 className="font-bold text-red-800 mb-3">🔥 Still Available - Limited Time:</h3>
            <ul className="text-red-700 text-sm space-y-2">
              <li>✅ Save up to $925 with presale pricing</li>
              <li>✅ 50% OFF setup fee (Save $250)</li>
              <li>✅ FREE 30-day beta access</li>
              <li>✅ 60-day money back guarantee</li>
              <li>✅ 60-day money back guarantee</li>
              <li>⏰ Only available for first 50 customers</li>
            </ul>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-center space-x-2 text-yellow-800">
              <Zap className="w-5 h-5" />
              <span className="font-semibold text-sm">Limited Time: Presale spots are filling up fast!</span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col space-y-3">
            <Button
              onClick={() => window.location.href = '/presale-checkout'}
              className="bg-gradient-to-r from-green-500 to-blue-500 text-white py-3 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all"
            >
              <DollarSign className="w-5 h-5 mr-2" />
              Complete My Presale Order
            </Button>
            
            <Button
              variant="outline"
              onClick={() => window.location.href = '/'}
              className="py-3 text-lg font-semibold rounded-lg"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Return to Homepage
            </Button>
          </div>

          <div className="text-center mt-6">
            <p className="text-xs text-gray-500">
              Questions? Contact us at gtdunn@ideaguybrands.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;